<sigv-extranet-header></sigv-extranet-header>
<div class="layout-main">
  <sigv-extranet-side-menu></sigv-extranet-side-menu>
  <div
    class="layout-content"
    [class.menu-hide]="(isMenuVisible$ | async) !== true"
    [class.header-hide]="(isHeaderVisible$ | async) !== true"
  >
    <div class="container">
      <ng-container *ngIf="((breadcrumb$ | async) || []).length > 0">
        <p-breadcrumb
          styleClass="p-mb-3"
          [model]="(breadcrumb$ | async) || []"
        ></p-breadcrumb>
      </ng-container>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<p-scrollTop [threshold]="20" icon="pi pi-arrow-up-white"></p-scrollTop>
<p-toast position="top-right" class="cfc-toast"></p-toast>
<app-footer></app-footer>
